import { useQuery } from '@tanstack/react-query'
import { api } from '@/services/api'

/** Fila de `channel_config` (`GET /calendar-config/channels`, només les habilitades). */
export interface ChannelConfig {
    id?: string
    channelName: string
    backgroundColor: string
    textColor: string
    borderColor: string
    icon?: string | null
    enabled: boolean
}

export const CHANNEL_CONFIGS_QUERY_KEY = ['channel-configs'] as const

/**
 * Colors dels canals configurats a `/config` → «Canals». Els llegeix també el tema del calendari
 * (`calendar-v2/calendar-theme.tsx`) per pintar la barra de cada card.
 */
export function useChannelConfigs() {
    return useQuery({
        queryKey: CHANNEL_CONFIGS_QUERY_KEY,
        queryFn: async () => {
            const response = await api.get<ChannelConfig[]>('/calendar-config/channels')
            return response.data
        },
        staleTime: 1000 * 60 * 5, // 5 minutes
    })
}
